import { Text as MagneticText, TextProps } from "@magnetic/text";

interface Props extends TextProps {}

export const Text = (props: Props) => {
  return <MagneticText {...props} />;
};
